'use client';

import { useAppSettings } from '@bells/core';
import { blogPostShareVia } from '@bells/i18n';
import { usePathname } from 'next/navigation';
import {
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  RedditShareButton,
  RedditIcon,
  TumblrShareButton,
  TumblrIcon,
} from 'react-share';

export const BlogSocial = ({ title }: { title: string }) => {
  const originalUrl = usePathname();
  const { frontendUrl } = useAppSettings();
  return (
    <>
      <div className='flex flex-wrap items-center gap-4'>
        <span className='text-sm font-medium uppercase text-muted-foreground'>
          {blogPostShareVia()}
        </span>
        <FacebookShareButton url={`${frontendUrl}${originalUrl}`}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>
        <TwitterShareButton url={`${frontendUrl}${originalUrl}`} title={title}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>
        <WhatsappShareButton url={`${frontendUrl}${originalUrl}`} title={title}>
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
        <TelegramShareButton url={`${frontendUrl}${originalUrl}`} title={title}>
          <TelegramIcon size={32} round />
        </TelegramShareButton>

        <RedditShareButton url={`${frontendUrl}${originalUrl}`} title={title}>
          <RedditIcon size={32} round />
        </RedditShareButton>
        <TumblrShareButton url={`${frontendUrl}${originalUrl}`} title={title}>
          <TumblrIcon size={32} round />
        </TumblrShareButton>
      </div>
    </>
  );
};
